import React from "react";

const Alert = ({ type = "success", message }) => {
  if (!message) return null;

  return (
    <div
      className={`mb-4 p-3 rounded text-sm text-center transition ${
        type === "success"
          ? "bg-green-100 text-green-700 border border-green-300"
          : "bg-red-100 text-red-700 border border-red-300"
      }`}
    >
      {message}
    </div>
  );
};

export default Alert;